import { render, staticRenderFns } from "./ContractPointRestrict.vue?vue&type=template&id=5a06fba3&scoped=true&"
import script from "./ContractPointRestrict.vue?vue&type=script&lang=js&"
export * from "./ContractPointRestrict.vue?vue&type=script&lang=js&"
import style0 from "./ContractPointRestrict.vue?vue&type=style&index=0&id=5a06fba3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a06fba3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCheckbox,VIcon})
